import React, { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { useDispatch, useSelector } from 'hooks/use-redux'
import type { EmailCampaign } from 'types/campaign'
import { campaignListGetAll } from '@disco/state-management/actions/campaign-list-actions'
import { getCampaignListSortedFiltered } from '@disco/state-management/selectors/campaigns'
import Spinner from 'components/ui/spinner'

const CampaignListLoader = (): React.ReactNode => {
  const dispatch = useDispatch()
  const campaigns: {
    loading: boolean
    loaded: boolean
    emailCampaigns: Array<EmailCampaign>
  } = useSelector(state => getCampaignListSortedFiltered(state, null))
  useEffect(() => {
    dispatch(campaignListGetAll())
  }, [])
  if (campaigns.loading) return <Spinner />
  return <Outlet />
}

export default CampaignListLoader
